<div class="badge-image-wrapper">
  <div class="badge-image-mask" [ngClass]="shape.toLowerCase()">
    <img
      *ngIf="shape === BadgeShape.Circle || shape === BadgeShape.Square"
      [src]="imageUrl || 'assets/icons/award.svg'"
      [ngStyle]="{
        'background-color': colorScheme?.background,
        'border-color': colorScheme?.border,
      }"
      alt="Badge preview"
    />

    <svg
      *ngIf="shape === BadgeShape.Shield"
      class="shield-svg"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      width="100%"
      height="100%"
    >
      <defs>
        <pattern [attr.id]="'badgePattern-' + imageUrl" patternUnits="userSpaceOnUse" width="100%" height="100%">
          <image [attr.href]="imageUrl || 'assets/icons/award.svg'" width="100%" height="100%" preserveAspectRatio="xMidYMid slice" />
        </pattern>
      </defs>

      <path
        d="M50 2
     L95 15 C96 25, 94 45, 90 60
     C80 85, 65 95, 50 98
     C35 95, 20 85, 10 60
     C6 45, 4 25, 5 15
     L50 2
     Z"
        [attr.fill]="colorScheme?.background"
      />

      <path
        d="M50 2
     L95 15 C96 25, 94 45, 90 60
     C80 85, 65 95, 50 98
     C35 95, 20 85, 10 60
     C6 45, 4 25, 5 15
     L50 2
     Z"
        [attr.fill]="'url(#badgePattern-' + imageUrl + ')'"
        [attr.stroke]="colorScheme?.border"
        stroke-width="2.5"
        vector-effect="non-scaling-stroke"
      />
    </svg>
  </div>

  <button *ngIf="isEditEnabled" class="change-image-button" (click)="imageInput.click()" type="button" aria-label="Change badge image">
    <mat-icon>edit</mat-icon>
  </button>
  <input #imageInput type="file" accept="image/*" (change)="onImageChange($event)" hidden />
</div>
